import { mutatorAction } from 'satcheljs';
import getStaleFlightUpdateStore from './store';

export const setStaleFlightUpdateAvailableMutator: (
    enabledChangeCount: number,
    disabledChangeCount: number,
    detectedAt: number
) => void = mutatorAction(
    'setStaleFlightUpdateAvailable',
    (enabledChangeCount: number, disabledChangeCount: number, detectedAt: number): void => {
        const store = getStaleFlightUpdateStore();
        store.isUpdateAvailable = true;
        store.enabledChangeCount = enabledChangeCount;
        store.disabledChangeCount = disabledChangeCount;
        store.detectedAt = detectedAt;
    }
);

export const setStaleFlightUpdateApplyingMutator: (isApplyingUpdate: boolean) => void =
    mutatorAction('setStaleFlightUpdateApplying', (isApplyingUpdate: boolean): void => {
        getStaleFlightUpdateStore().isApplyingUpdate = isApplyingUpdate;
    });
